import { ITEM_CATALOG } from './itemCatalog.js';
import {
  findStackableSlot,
  createStackedSlot,
  tryIncrementStack,
  canAddConsumableStack,
  CONSUMABLE_REFUSE_UNIQUE_MAX
} from './consumableStacks.js';
import {
  createStackPurchaseRecord,
  createNewPurchaseRecord,
  createCraftPurchaseRecord
} from './shopPurchaseUndo.js';
import { canBuyBootsItem } from './bootsMsFidelity.js';
import { SHOP_REFUSE_REASONS } from './shopRefuseReasons.js';

export function buyConsumable(inventory, itemDef, finalCost) {
  if (!canAddConsumableStack(inventory.slots, itemDef)) {
    return { success: false, reason: CONSUMABLE_REFUSE_UNIQUE_MAX };
  }
  const deathShop = Boolean(inventory.owner?.isDead);
  const stackIdx = findStackableSlot(inventory.slots, itemDef.id);
  if (stackIdx !== -1) {
    tryIncrementStack(inventory.slots[stackIdx]);
    inventory.owner.gold -= finalCost;
    inventory.lastPurchase = createStackPurchaseRecord(
      stackIdx, itemDef.id, finalCost, deathShop
    );
    return { success: true, slotIndex: stackIdx, item: itemDef, costPaid: finalCost };
  }

  const emptySlotIndex = inventory.slots.findIndex((slot) => slot === null);
  if (emptySlotIndex === -1) {
    return { success: false, reason: 'Inventario lleno (Máx 6 objetos)' };
  }

  inventory.slots[emptySlotIndex] = createStackedSlot(itemDef);
  inventory.owner.gold -= finalCost;
  inventory.lastPurchase = createNewPurchaseRecord(
    emptySlotIndex, itemDef.id, finalCost, deathShop
  );
  inventory.recalculateStats();
  return { success: true, slotIndex: emptySlotIndex, item: itemDef, costPaid: finalCost };
}

function collectConsumedIndexes(slots, components) {
  const consumed = [];
  if (!components || components.length === 0) return consumed;
  const tempSlots = [...slots];
  components.forEach((compKey) => {
    const idx = tempSlots.findIndex(
      (s, i) => s && s.id === compKey && !consumed.includes(i)
    );
    if (idx !== -1) consumed.push(idx);
  });
  return consumed;
}

export function buyEquipment(inventory, itemDef, finalCost) {
  const consumedSlotIndexes = collectConsumedIndexes(inventory.slots, itemDef.components);
  const availableFreeSlots = inventory.slots.filter(
    (s, i) => s === null || consumedSlotIndexes.includes(i)
  ).length;
  if (availableFreeSlots === 0) {
    return { success: false, reason: 'Inventario lleno (Máx 6 objetos)' };
  }

  const consumed = consumedSlotIndexes.map((idx) => ({
    index: idx,
    snapshot: { ...inventory.slots[idx] }
  }));
  consumedSlotIndexes.forEach((idx) => {
    inventory.slots[idx] = null;
  });

  const emptySlotIndex = inventory.slots.findIndex((slot) => slot === null);
  inventory.slots[emptySlotIndex] = { ...itemDef };
  inventory.owner.gold -= finalCost;
  inventory.recalculateStats();
  const deathShop = Boolean(inventory.owner?.isDead);

  if (consumed.length > 0) {
    inventory.lastPurchase = createCraftPurchaseRecord(
      emptySlotIndex, itemDef.id, finalCost, consumed, deathShop
    );
  } else {
    inventory.lastPurchase = createNewPurchaseRecord(
      emptySlotIndex, itemDef.id, finalCost, deathShop
    );
  }

  return { success: true, slotIndex: emptySlotIndex, item: itemDef, costPaid: finalCost };
}

export function resolveBuy(inventory, itemId) {
  const itemDef = ITEM_CATALOG[itemId];
  if (!itemDef) return { success: false, reason: 'Objeto no válido' };
  if (!canBuyBootsItem(inventory.slots, itemId)) {
    return { success: false, reason: SHOP_REFUSE_REASONS.ALREADY_OWNED };
  }
  const finalCost = inventory.getItemCraftingCost(itemId);
  if (inventory.owner.gold < finalCost) {
    return { success: false, reason: 'Oro insuficiente' };
  }
  if (itemDef.isConsumable) return buyConsumable(inventory, itemDef, finalCost);
  return buyEquipment(inventory, itemDef, finalCost);
}
